import {NodeCreationResult} from '@ispm-client/modules/bpmn-modeler/models/node-creation-result';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import {select, Store} from '@ngrx/store';
import {selectNodeCreationInfoById} from '@ispm-client/modules/bpmn-modeler/store/selectors';
import {map, take} from 'rxjs/operators';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {PathwaysModeling} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import {State} from '@ispm-client/modules/bpmn-modeler/store/state';
import {Shape} from 'diagram-js/lib/model';
import {map as lodashMap, without} from 'lodash';

/**
 * Created By Elia Rohana on 8/5/19
 */

export class NeighborhoodHeadNameUpdater {


    constructor(private modeling, private pathwaysModeling: PathwaysModeling, private store$: Store<State>, private elementRegistry) {
    }

    updateAll() {
        const neighborhoodNodeHeadArray = this.elementRegistry.filter(element => NodeType.neighborhood_head === ModelingUtil.getNodeType(element) && !element.id.endsWith("plane"));
        neighborhoodNodeHeadArray.forEach(node => this.updateName(node));
    }

    updateName(neighborhoodNodeHead: Shape) {
        const name = this.generateNeighborhoodHeadName(neighborhoodNodeHead);
        let requireUpdate = true;
        this.getChildrenData$([neighborhoodNodeHead.id]).subscribe((nodeCreationResultsDataArr: Array<NodeCreationResult>) => {
            const nodeCreationResult: NodeCreationResult = {ruleset: null, id: neighborhoodNodeHead.id, name};
            if (nodeCreationResultsDataArr && nodeCreationResultsDataArr.length > 0) {
                requireUpdate = false;
                const data = nodeCreationResultsDataArr[0];
                // in this case only the name could be changed
                if (data.name !== nodeCreationResult.name) {
                    requireUpdate = true;
                    nodeCreationResult.ruleset = data.ruleset;
                    nodeCreationResult.guideBox = data.guideBox;
                }
            }
            if (requireUpdate) {
                this.pathwaysModeling.updateNodeData(neighborhoodNodeHead, nodeCreationResult, NodeType.neighborhood_head);
            }
        });
    }

    private getChildrenData$(childrenNodesIds: Array<string>) {
        return this.store$.pipe(select(selectNodeCreationInfoById(childrenNodesIds)),
            map(nodeCreationInfoArray => without(lodashMap(nodeCreationInfoArray, 'data'), null, undefined)),
            take(1));
    }

    private generateNeighborhoodHeadName(neighborhoodEntryNode: Shape) {
        const parentsPaths = ModelingUtil.getNodePathsToRoot(neighborhoodEntryNode);
        parentsPaths.forEach(path => {
            this.removeRootNode(path);
            path.reverse();
        });

        const pathsNameArr = [];
        for (let i = 0; i < parentsPaths.length; i++) {
            const pathNameArr = [];
            const parentsLength = parentsPaths[i].length;
            if (i >= 1 && parentsPaths.length > 1) {
                pathsNameArr.push('OR');
            }
            for (let j = 0; j < parentsLength; j++) {
                pathNameArr.push(parentsPaths[i][j].businessObject.name);
            }
            const pathName = pathNameArr.join(',\n');
            pathsNameArr.push(pathName);
        }
        return pathsNameArr.join('\n');
    }

    private removeRootNode(path) {
        const node = path.pop();
        if (node && node.id !== 'head_node_id') {
            // Push back the removed node - it's not the root
            path.push(node);
        }
    }
}
